import { useEffect } from 'react';
import { useContador } from "../../hooks/turns/useContador";
import { useTiempo } from '../../hooks/turns/useTiempo';
import { Tooltip } from '@mui/material';

const estados = [
    { color: '#7cb342', titulo: 'Vigente'  },
    { color: '#ffb300', titulo: 'Por vencer'  },
    { color: '#ef5350', titulo: 'Vencido'  }
];

export const Estado = ({ estado, fecha, tiempo, children }) => {

    const { contador, iniciarContador } = useContador(fecha, estado);
    const { estatus } = useTiempo(contador, tiempo);

    useEffect(() => {
        let unsubscribed = true;
        
        unsubscribed && iniciarContador();

        return () => unsubscribed = false;
    }, [fecha]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <Tooltip title={ estados[estatus]?.titulo }>
                <div style={{ background: estados[estatus]?.color, padding: '2px 6px', borderRadius: 6, cursor: 'default' }}>
                   { children }
                </div>
            </Tooltip>
        </div>
    )
}